import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"

import { useCompanyArticlesFetch } from "@/modules/companies/client/hooks/useCompanyArticlesFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./ArticlesTitle.module.css"

export const ARTICLE_TITLE_ID = "news"

export const ArticlesTitle: FunctionComponent = () => {
  const { dataCompanyArticles } = useCompanyArticlesFetch()
  const { t } = useTranslation(["companies_client"])

  return (
    <Heading
      variant="title2"
      weight="bold"
      as="h2"
      className={styles.main}
      data-testid="company_news_feed_article_title"
      id={ARTICLE_TITLE_ID}
    >
      {t("companies_client.newsFeed.articles.title", { count: dataCompanyArticles ? dataCompanyArticles.total : 0 })} (
      {dataCompanyArticles ? dataCompanyArticles.total : 0})
    </Heading>
  )
}
